import React from 'react';
import { StarIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
export function StickyProductCard() {
  return <div className="sticky top-24 bg-white rounded-xl shadow-xl p-6 border border-gray-200" data-id="element-396">
      {/* Product Image */}
      <div className="bg-gradient-to-br from-pink-50 to-amber-50 rounded-lg overflow-hidden mb-6" data-id="element-397">
        <div className="aspect-square" data-id="element-398">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/jVKDSAQ5RdXXLVy1R75x8M/f11daba2-3745-4b32-9083-cb976db9b7ad_%281%29.png" alt="Silk Lifting Peptide Ampoule with visible gold threads" className="w-full h-full object-cover" data-id="element-399" />
        </div>
      </div>

      {/* Customer Reviews Section */}
      <div className="mb-6" data-id="element-400">
        <h3 className="text-xl font-bold text-gray-900 mb-3" data-id="element-401">
          Customer Reviews
        </h3>

        {/* Star Rating */}
        <div className="flex items-center gap-2 mb-2" data-id="element-402">
          <div className="flex gap-1" data-id="element-403">
            {[...Array(4)].map((_, i) => <StarIcon key={i} className="w-5 h-5 fill-yellow-400 text-yellow-400" data-id="element-404" />)}
            <StarIcon className="w-5 h-5 fill-yellow-400 text-yellow-400" style={{
            clipPath: 'inset(0 50% 0 0)'
          }} data-id="element-405" />
          </div>
          <span className="font-bold text-gray-900" data-id="element-406">4.8 out of 5</span>
        </div>

        <p className="text-sm text-gray-600 mb-4" data-id="element-407">2,471 customer ratings</p>

        {/* Rating Bars */}
        <div className="space-y-2" data-id="element-408">
          <div className="flex items-center gap-3" data-id="element-409">
            <span className="text-sm font-medium text-gray-700 w-16" data-id="element-410">
              5 Star
            </span>
            <div className="flex-1 bg-gray-200 rounded-full h-4 overflow-hidden" data-id="element-411">
              <div className="bg-yellow-400 h-full rounded-full" style={{
              width: '90%'
            }} data-id="element-412"></div>
            </div>
            <span className="text-sm font-bold text-gray-900 w-12 text-right" data-id="element-413">
              90%
            </span>
          </div>

          <div className="flex items-center gap-3" data-id="element-414">
            <span className="text-sm font-medium text-gray-700 w-16" data-id="element-415">
              4 Star
            </span>
            <div className="flex-1 bg-gray-200 rounded-full h-4 overflow-hidden" data-id="element-416">
              <div className="bg-yellow-400 h-full rounded-full" style={{
              width: '7%'
            }} data-id="element-417"></div>
            </div>
            <span className="text-sm font-bold text-gray-900 w-12 text-right" data-id="element-418">
              7%
            </span>
          </div>

          <div className="flex items-center gap-3" data-id="element-419">
            <span className="text-sm font-medium text-gray-700 w-16" data-id="element-420">
              3 Star
            </span>
            <div className="flex-1 bg-gray-200 rounded-full h-4 overflow-hidden" data-id="element-421">
              <div className="bg-yellow-400 h-full rounded-full" style={{
              width: '2%'
            }} data-id="element-422"></div>
            </div>
            <span className="text-sm font-bold text-gray-900 w-12 text-right" data-id="element-423">
              2%
            </span>
          </div>

          <div className="flex items-center gap-3" data-id="element-424">
            <span className="text-sm font-medium text-gray-700 w-16" data-id="element-425">
              2 Star
            </span>
            <div className="flex-1 bg-gray-200 rounded-full h-4 overflow-hidden" data-id="element-426">
              <div className="bg-yellow-400 h-full rounded-full" style={{
              width: '0%'
            }} data-id="element-427"></div>
            </div>
            <span className="text-sm font-bold text-gray-900 w-12 text-right" data-id="element-428">
              0%
            </span>
          </div>

          <div className="flex items-center gap-3" data-id="element-429">
            <span className="text-sm font-medium text-gray-700 w-16" data-id="element-430">
              1 Star
            </span>
            <div className="flex-1 bg-gray-200 rounded-full h-4 overflow-hidden" data-id="element-431">
              <div className="bg-yellow-400 h-full rounded-full" style={{
              width: '1%'
            }} data-id="element-432"></div>
            </div>
            <span className="text-sm font-bold text-gray-900 w-12 text-right" data-id="element-433">
              1%
            </span>
          </div>
        </div>
      </div>

      {/* CTA Button */}
      <CTAButton size="large" className="w-full text-center" data-id="element-434">
        GET UP TO 71% OFF SILK LIFTING AMPOULE NOW!
      </CTAButton>
    </div>;
}